import { render, staticRenderFns } from "./NotificationCenter.vue?vue&type=template&id=1b8bfa6e&scoped=true"
import script from "./NotificationCenter.vue?vue&type=script&lang=js"
export * from "./NotificationCenter.vue?vue&type=script&lang=js"
import style0 from "./NotificationCenter.vue?vue&type=style&index=0&id=1b8bfa6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8bfa6e",
  null
  
)

export default component.exports